import { BookCard, type BookCardBook } from './book-card';

interface BookListProps {
    books: BookCardBook[];
    emptyTitle?: string;
    emptyDescription?: string;
    layout?: 'grid' | 'pinned';
    showPin?: boolean;
}

export function BookList({
    books,
    emptyTitle = 'No books found',
    emptyDescription = 'Try changing your search, filter, or sort options.',
    layout = 'grid',
    showPin = false,
}: BookListProps) {
    if (books.length === 0) {
        return (
            <div className="border-border bg-muted/30 rounded-lg border p-10 text-center">
                <h2 className="text-lg font-semibold">{emptyTitle}</h2>
                <p className="text-muted-foreground mt-2 text-sm">{emptyDescription}</p>
            </div>
        );
    }

    if (layout === 'pinned') {
        return (
            <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5">
                {books.map(book => (
                    <BookCard
                        key={book.id}
                        book={book}
                        compact
                        showPin={showPin}
                    />
                ))}
            </div>
        );
    }

    return (
        <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-4">
            {books.map(book => (
                <BookCard
                    key={book.id}
                    book={book}
                    showPin={showPin}
                />
            ))}
        </div>
    );
}
